import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useDeliveryService } from "../../../services/deliveryService"
import { ReturnItemRow, NoteGenerationType } from "../../types"
import { useSaleOperationLoaders } from "../../../../sales"
import { useFiscalDocumentLoaders } from "../../../../fiscal-documents"
import { useAdjustmentNoteLoaders } from "../../../../administration"

export const useActions = () => {
    const saleOperationLoaders = useSaleOperationLoaders()
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()
    const adjustmentNoteLoaders = useAdjustmentNoteLoaders()

    const { returnShipmentItems } = useDeliveryService()

    const { closeModal } = useUIActions()

    const submitReturn = async (
        table: TableName,
        operationId: string,
        itemRows: ReturnItemRow[],
        noteType: NoteGenerationType
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            await returnShipmentItems(table, operationId, itemRows, noteType)

            const { loadSaleOperation } = saleOperationLoaders()
            await loadSaleOperation(table, operationId, true)
            const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
            await loadOperationFiscalDocuments(operationId, false)
            const { loadOperationAdjustmentNotes } = adjustmentNoteLoaders()
            await loadOperationAdjustmentNotes(operationId, false)

            Emitter.emit(Event.DB_SUBMIT_DONE, true)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar la nota de crédito.')
        }
    }
    
    return {
        submitReturn
    }
}
